// BS26 "B26 join" page — filterable preview grid of the sale catalog (section lp-bs26-b26-join, root #b26j-grid).
// Axes = window.B26J_FILTERS.axes (per-brand menu, built by prototype/enrich-bs26-catalog-with-menu-recipient-meaning-type-filters.mjs;
// Afroyla "Looks like her"+"Message", Skullette "Story & vibe", Lettoria "Book") PLUS a Product type axis built here from SLQ_CATALOG.type
// (skipped if the map already defines a 'type' axis, so the filter is never duplicated). Missing B26J_FILTERS → Type-only grid.
// Coverage is NOT 100% (ops tags real products, not every item) — an item without a tag on an axis is excluded ONLY once a filter on
// that axis is selected; with no filter set on an axis it is never hidden by that axis.
// Filters (anh 11-03: chip walls → dropdowns): one native <select> per axis, AND across axes. Each option shows how many pieces it
// would leave given the OTHER axes' picks; 0-result options are disabled (no dead ends). Price = "From $p4" (anh: never "4+ piece
// price", too much effort; p4 is the true floor, same as the hero's "Bags from"). 12/24 tiles + Show more. Tap a photo → SLQ_ZOOM (B26 join
// lives in that dialog). No PDP links, no add-to-cart — this page only previews the sale.
(function () {
  const C = window.SLQ_CONFIG, T = window.SLQ_TRACK || { listAction() {} };
  const root = document.getElementById('b26j-grid');
  if (!root) return;
  const MIN_STOCK = 5; // same floor as the "All designs" browser — never preview a piece that sells out first
  const PAGE = window.matchMedia('(max-width: 899px)').matches ? 12 : 24; // mobile: 12 tiles (~2 screens) so the FAQ + end card stay reachable
  const TYPE_ORDER = ['handbag', 'small handbag', 'tote', 'crossbody', 'backpack', 'wallet', 'mini wallet', 'makeup bag', 'charm'];
  const TYPE_LABEL = { handbag: 'Handbags', 'small handbag': 'Small handbags', tote: 'Totes', crossbody: 'Crossbody bags', backpack: 'Backpacks', wallet: 'Wallets', 'mini wallet': 'Mini wallets', 'makeup bag': 'Makeup bags', charm: 'Charms' };
  const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const $ = (n) => '$' + n.toFixed(2);

  const catalog = (window.SLQ_CATALOG || []).filter((p) => p.img && (p.stock == null || p.stock >= MIN_STOCK));
  const rankOf = {}; (window.SLQ_PRODUCTS || []).forEach((p) => { rankOf[p.design] = Math.min(rankOf[p.design] || 99, p.rank); });
  const marqueeIdx = {}; (C.marqueeDesigns || []).forEach((d, i) => { marqueeIdx[d] = i; });

  // Axes: per-brand menu axes (handles-based) + a Type axis built from the catalog, unless the map already has one.
  const mapAxes = (window.B26J_FILTERS && window.B26J_FILTERS.axes) || [];
  const typeOptions = TYPE_ORDER.filter((t) => catalog.some((p) => p.type === t))
    .map((t) => ({ key: t, label: TYPE_LABEL[t] || t, handles: catalog.filter((p) => p.type === t).map((p) => p.handle) }));
  const axes = mapAxes.concat(mapAxes.some((a) => a.key === 'type') ? [] : [{ key: 'type', label: 'Product type', options: typeOptions }]);

  // handlesByOption[axisKey][optionKey] = Set<handle> — built once from each axis's own options[].handles.
  const handlesByOption = {};
  axes.forEach((a) => { handlesByOption[a.key] = {}; (a.options || []).forEach((o) => { handlesByOption[a.key][o.key] = new Set(o.handles || []); }); });
  // Hide an option with 0 real items in this brand's catalog.
  axes.forEach((a) => { a.options = (a.options || []).filter((o) => handlesByOption[a.key][o.key].size > 0); });

  const selected = {}; // axisKey -> option key, or null = "All"
  let shown = PAGE;

  function matches(p) {
    return axes.every((a) => {
      const opt = selected[a.key];
      if (!opt) return true; // no filter on this axis → never excluded by it
      const set = handlesByOption[a.key][opt];
      return set && set.has(p.handle);
    });
  }

  // Round-robin by design (lead QA 11-03: default order repeated one design 4x before moving on) — one tile per design per
  // pass (design order = rank/marquee/alpha, same as before; handbag preferred as each design's first tile via TYPE_ORDER),
  // then a second tile per design, etc. Same interleave for the default list and every filtered result.
  function sorted(list) {
    const order = [], byDesign = {};
    list.forEach((p) => { if (!byDesign[p.design]) { byDesign[p.design] = []; order.push(p.design); } byDesign[p.design].push(p); });
    order.sort((a, b) => (rankOf[a] ?? 99) - (rankOf[b] ?? 99) || (marqueeIdx[a] ?? 99) - (marqueeIdx[b] ?? 99) || a.localeCompare(b));
    order.forEach((d) => byDesign[d].sort((a, b) => TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type)));
    const out = []; for (let i = 0; order.some((d) => byDesign[d][i]); i++) order.forEach((d) => { if (byDesign[d][i]) out.push(byDesign[d][i]); });
    return out;
  }

  // Count of pieces an option would leave, holding the other axes' current picks (faceted counts).
  function countIf(axisKey, optKey) {
    const keep = selected[axisKey]; selected[axisKey] = optKey;
    const n = catalog.filter(matches).length; selected[axisKey] = keep; return n;
  }

  function selectHtml(axis) {
    const cur = selected[axis.key] || '', id = 'b26j-dd-' + axis.key;
    return `<label class="b26j-dd${cur ? ' is-on' : ''}" for="${id}"><span>${axis.label}</span>` +
      `<select id="${id}" data-b26j-axis="${axis.key}" data-hc-el="b26j-filter-${axis.key}"><option value="">All (${countIf(axis.key, null)})</option>` +
      axis.options.map((o) => { const n = countIf(axis.key, o.key); return `<option value="${o.key}"${o.key === cur ? ' selected' : ''}${n || o.key === cur ? '' : ' disabled'}>${o.label} (${n})</option>`; }).join('') +
      '</select></label>';
  }

  function tileHtml(p) {
    const img = window.SLQ_LOGIC.cdnW(p.img, 360);
    return `<button class="b26j-tile" data-b26j-zoom="${p.handle}" data-hc-el="b26j-grid-zoom-${slug(p.handle)}">` +
      `<img src="${img}" alt="${p.design} ${p.type}" width="180" height="180" loading="lazy">` +
      `<strong>${p.design} <span class="b26j-tile__type">${p.label || p.type}</span></strong>` +
      `<span class="slq-price"><small class="b26j-from">From</small> <b>${$(p.p4)}</b> <s>${$(p.list)}</s></span></button>`;
  }

  // Polish 11-03: filters / status / tiles live in 3 persistent slots, so the aria-live result count is announced on every
  // filter tap (a node re-created by innerHTML is not), and the shopper always sees how many pieces match + a way back.
  root.innerHTML = '<div data-b26j-slot="chips"></div><div class="b26j-status" role="status" aria-live="polite" data-b26j-slot="status"></div><div data-b26j-slot="list"></div>';
  const slot = (k) => root.querySelector(`[data-b26j-slot="${k}"]`);
  const word = (n) => n + (n === 1 ? ' piece' : ' pieces');

  function render() {
    const list = sorted(catalog.filter(matches));
    const page = list.slice(0, shown);
    const filtered = Object.keys(selected).some((k) => selected[k]);
    // keep focus on the dropdown the shopper just used (innerHTML re-creates the selects)
    const focusAxis = document.activeElement && document.activeElement.dataset ? document.activeElement.dataset.b26jAxis : null;
    slot('chips').innerHTML = `<div class="b26j-dds">${axes.map(selectHtml).join('')}</div>`;
    if (focusAxis) { const d = slot('chips').querySelector(`[data-b26j-axis="${focusAxis}"]`); if (d) d.focus({ preventScroll: true }); }
    slot('status').innerHTML = `<span>${word(list.length)}${filtered ? (list.length === 1 ? ' matches' : ' match') : ' in the sale preview'}</span>` +
      (filtered && list.length ? '<button class="b26j-status__clear" data-b26j-clear data-hc-el="b26j-filter-clear-inline">Clear filters</button>' : '');
    if (!list.length) {
      slot('list').innerHTML = `<p class="b26j-empty">${root.dataset.empty || 'Nothing matches these filters.'}</p>` +
        '<button class="slq-ghost b26j-clear" data-b26j-clear data-hc-el="b26j-filter-clear">Clear filters</button>';
      return;
    }
    slot('list').innerHTML = `<div class="b26j-tiles">${page.map(tileHtml).join('')}</div>` +
      (list.length > shown ? `<button class="slq-ghost b26j-more" data-b26j-more data-hc-el="b26j-grid-more">Show more (${list.length - shown} left)</button>` : '');
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-b26j-clear]')) { Object.keys(selected).forEach((k) => (selected[k] = null)); shown = PAGE; T.listAction('b26j-filter-clear'); render(); return; }
    if (e.target.closest('[data-b26j-more]')) { shown += PAGE; T.listAction('b26j-more', shown); render(); return; }
    const zoom = e.target.closest('[data-b26j-zoom]');
    if (zoom && window.SLQ_ZOOM) { const p = catalog.find((x) => x.handle === zoom.dataset.b26jZoom); if (p) window.SLQ_ZOOM.open({ img: p.img, title: p.design, sub: `${p.label || p.type} · from ${$(p.p4)} (was ${$(p.list)})`, where: 'grid' }); }
  });

  root.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-b26j-axis]');
    if (!sel) return;
    selected[sel.dataset.b26jAxis] = sel.value || null;
    shown = PAGE; T.listAction('b26j-filter', sel.dataset.b26jAxis + ':' + (sel.value || 'all')); render();
  });

  render(); // filter/show-more taps happen inside the grid itself — never force a scroll the shopper didn't ask for
})();
